<template>
  <div class="homen" style="width: 100%;margin: auto;min-height: 480px;padding-top: 40px">
<div class="abb" ><el-button @click="onButton1" >信用查询</el-button><el-button @click="onButton2" style="margin-left: 30px">认证查询</el-button><el-button @click="onButton3" style="margin-left: 30px">资质查询</el-button></div>
<el-form v-if="lv == 1" :model="formInline" :rules="rules" ref="formInline" :inline="true"  class="demo-form-inline searchbar">
  <el-form-item   label="信用查询" prop="eName">
    <el-input style="width: 600px" v-model="formInline.eName" placeholder="请输入企业名称、统一社会信用代码或证书编号"></el-input>
  </el-form-item>
  <el-form-item  >
    <el-button type="primary" @click="onSubmitxy(formInline)">查询</el-button>
  </el-form-item>
</el-form>
<el-form v-if="lv == 2" :model="formInline" :rules="rules" ref="formInline" :inline="true"  class="demo-form-inline searchbar">
  <el-form-item label="认证查询" prop="eName1">
    <el-input style="width: 600px" v-model="formInline.eName1" placeholder="请输入企业名称、统一社会信用代码或证书编号"></el-input>
  </el-form-item>
  <el-form-item >
    <el-button type="primary" @click="onSubmitrz(formInline)">查询</el-button>
  </el-form-item>
          </el-form>
<el-form v-if="lv == 3" :model="formInline" :rules="rules" ref="formInline" :inline="true"  class="demo-form-inline searchbar">
  <el-form-item  label="资质查询" prop="eName2">
    <el-input style="width: 600px" v-model="formInline.eName2" placeholder="请输入企业名称、统一社会信用代码或证书编号"></el-input>
  </el-form-item>

  <el-form-item >
    <el-button type="primary" @click="onSubmitzz(formInline)">查询</el-button>
  </el-form-item>
</el-form>
    <div style="width: 1180px;margin: auto;margin-top: 20px">
      <div style="width: 650px;float: left">
     <el-carousel height="300px" >
    <el-carousel-item v-for="(item,index) in listImg" :key="index" >
      <router-link  :to="{path:'/news', query: { id: item.id }}" target="_blank">
       <img  v-if="index < 3" :src= imgUrl+item.imgUrl height="300"
           width="650px"/>
      </router-link>
    </el-carousel-item>
  </el-carousel>
      </div>
       <div style="width: 490px;float: left;margin-left: 3%">
    <div class="box-title">
      <strong>
      <router-link :to="{path:'/xydt'}" target="_blank">
        信用动态
      </router-link>
        </strong>
      <div style="float: right;font-size: 14px;color: #888888;margin-top: 6px"><router-link :to="{path:'/xydt'}" target="_blank" style="color: #888888;text-decoration:none">更多>></router-link></div>
    </div>
    <div class="recommend4">
        <ul style="width: 500px;float: left">
           <li  v-for="(item,index) in list" :key="index"  :index="item.path" >
            <div style="width: 400px;    overflow: hidden;
    text-overflow: ellipsis;float: left"> <router-link  :to="{path:'/news', query: { id: item.id }}" target="_blank">
               {{ item.title }}
           </router-link></div>
             <div style="float: right;margin-right: 10px;">{{item.publishDate.slice(5,10)}}</div>
           </li>
            </ul>
    </div>
      </div>
      </div>
<!--    <div style="width: 1180px;margin: auto">-->
<!--      <img src="../assets/img/xyzg1.png" height="100" width="398"/>-->
<!--      <img src="../assets/img/gxb.png" height="100" width="777"/>-->
<!--    </div>-->
       <div style="width: 1180px;margin: 20px auto 20px;">
        <div class="box-title" style="margin-bottom: 20px">
      <strong>

        信用公示

        </strong>
   </div>
          <el-table
    :data="listCredit"
    border
    style="width: 100%">
    <el-table-column
      prop="entName"
      label="企业名称"
      width="368">
    </el-table-column>
    <el-table-column
      prop="gradeName"
      label="信用等级"
      width="120">
    </el-table-column>
    <el-table-column
      prop="certificateNumber"
      label="证书编号"
      width="320">
    </el-table-column>
    <el-table-column
      prop="ratingTime"
      label="颁发日期"
      width="160">
    </el-table-column>
    <el-table-column
      prop="effectiveEnd"
      label="有效期至"
      width="160">
    </el-table-column>
    <el-table-column
      label="详细"
      width="50">
      <template slot-scope="scope">
        <el-button @click="handleClick(scope.row.id)" type="text" size="small">查看</el-button>
      </template>
    </el-table-column>
  </el-table>
       </div>
<!--    <div style="width: 1180px;margin: auto">-->
<!--      <img src="../assets/img/rmyh.png" height="100" width="398"/>-->
<!--      <img src="../assets/img/fgw.png" height="100" width="777"/>-->
<!--    </div>-->
<!--    <div class="bottonbanner" style="width: 100%;min-height: 360px;margin: 20px 0px 20px 0px">-->
<!--      <div style="width: 700px;margin: auto ;">-->
<!--     <div style="width: 680px;font-size: 30px;font-weight: bold;padding-top: 28px;height: 35px">-->
<!--       <img src="../assets/img/r.png"  style="float: left;width: 44px;height: 44px"/>-->
<!--       <div style="float: left;margin-left: 20px;width: 600px">中小企业诚信联盟</div>-->
<!--     </div>-->
<!--     <div style="width: 680px;font-size: 20px;font-weight: bold;margin-top: 40px;height: 45px"><div style="width: 150px;float: left"> 联盟发起单位:</div><div style="width: 400px;float: left"><img style="float: left" src="../assets/img/zxwlogo.png" height="55" width="309"/></div></div>-->
<!--     <div style="width: 820px;font-size: 20px;font-weight: bold;margin-top: 40px;height: 35px"> <div style="width: 200px;float: left">联盟共同发起单位: </div><img style="float: left" src="../assets/img/jm.png" height="152" width="606"/></div>-->
<!--      </div>-->
<!--  </div>-->
<!--    查询版-->
  </div>
</template>

<script>
import { list } from '@/api/news'
import { creditTop } from '@/api/home'
import Pagination from '@/components/Pagination'
export default {
  name: 'Home',
  components: {
    Pagination
  },
  data () {
    return {
      // imgUrl: 'http://192.168.1.92:8800',
      imgUrl: 'https://events.sme.com.cn/api',
      channel: [],
      list: null,
      list2: null,
      listImg: null,
      listCredit: null,
      listLoading: true,
      index: '',
      sortIndex: 0,
      carouselIndex: 0,
      currentPage: 1,
      limit: 10,
      total: 0,
      formInline: {
        eName: '',
        eName1: '',
        eName2: ''
      },
      rules: {
        eName: [
          { required: true, message: '请输入企业名称、统一社会信用代码或证书编号', trigger: 'blur' }
        ],
        eName1: [
          { required: true, message: '请输入企业名称、统一社会信用代码或证书编号', trigger: 'blur' }
        ],
        eName2: [
          { required: true, message: '请输入企业名称、统一社会信用代码或证书编号', trigger: 'blur' }
        ]
      },
      lv: 1
    }
  },
  created () {
    this.fetchData()
    this.fetchData2()
    this.fetchCredit()
    this.fetchImg()
  },
  methods: {

    onSubmitxy (formInline) {
      var that = this
      var ename = that.formInline.eName
      this.$refs.formInline.validate((valid) => {
        if (valid) {
          window.location.href = '/static/creditSearchAll.html' + '?eName=' + ename
        } else {
          console.log('error submit!!')
          return false
        }
      })
      // this.$router.push({path:'static/creditSearchAll.html',query:{'eName' : this.eName}})
    },
    onSubmitrz () {
      var that = this
      var ename = that.formInline.eName1
      console.log(that.formInline)
      // this.$router.push({path:'static/creditSearchAll.html',query:{'eName' : this.eName}})
      this.$refs.formInline.validate((valid) => {
        console.log(valid)
        if (valid) {
          window.location.href = '/static/rzcx.html' + '?eName=' + ename
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    onSubmitzz () {
      var that = this
      var ename = that.formInline.eName2
      // this.$router.push({path:'static/creditSearchAll.html',query:{'eName' : this.eName}})
      this.$refs.formInline.validate((valid) => {
        if (valid) {
          window.location.href = '/static/zzcx.html' + '?eName=' + ename
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },

    onButton1 () {
      var that = this
      that.formInline.eName = ''
      this.lv = 1
    },
    onButton2 () {
      var that = this
      that.formInline.eName = ''
      this.lv = 2
    },
    onButton3 () {
      var that = this
      that.formInline.eName = ''
      this.lv = 3
    },
    fetchData () {
      list({ currentPage: this.currentPage, channelId: '0', pagenow: this.currentPage, pageSize: 6 }).then(response => {
        if (response.result === 1) {
          this.total = response.data.total
          this.list = response.data.list
          // const list1 = this.list
          // this.list2 = list1
          // console.log(this.list)
        } this.listLoading = false
      }).catch(() => {
        this.$message({
          message: '加载失败', type: 'warning'
        })
      })
    },
    fetchData2 () {
      list({ currentPage: this.currentPage, channelId: '2', pagenow: this.currentPage, pageSize: 4 }).then(response => {
        if (response.result === 1) {
          this.total = response.data.total
          this.list2 = response.data.list
          console.log(this.listImg)
        } this.listLoading = false
      }).catch(() => {
        this.$message({
          message: '加载失败', type: 'warning'
        })
      })
    },
    fetchCredit () {
      creditTop().then(response => {
        if (response.result === 1) {
          this.listCredit = response.data
        } this.listLoading = false
      }).catch(() => {
        this.$message({
          message: '加载失败', type: 'warning'
        })
      })
    },
    fetchImg () {
      list({ currentPage: this.currentPage, channelId: '0', pagenow: this.currentPage, pageSize: 19 }).then(response => {
        if (response.result === 1) {
          this.listImg = response.data.list.splice(0, 3)
        }
      }).catch(() => {
        this.$message({
          message: '加载失败', type: 'warning'
        })
      })
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.fetchData()
    },
    handleSizeChange (val) {
      this.limit = val
      this.currentPage = 1
      this.fetchData()
    },
    handleClick (id) {
      window.location.href = '/static/xxgsjg.html' + '?entid=' + id
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
<style>
  /*.homen{background: url(../assets/img/dingbak.png) no-repeat center;background-size:100% 100%;}*/
  .el-main{
    padding: 0px !important;
    /*background-color: #f5f5f500;*/

  }
   .listNews{
    height: 40px;
    width: 590px;
   margin-bottom: 8px;
    line-height: 35px;
    font-size: 28px;
    font-weight: bold;
    float: left;
    padding-left: 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #444444;
  }
  .listNews1{
    height: 40px;
    width: 590px;
   margin-bottom: 8px;
    line-height: 35px;
    font-size: 18px;
    font-weight: normal;
    float: left;
    padding-left: 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #555555;
  }
  .box-title{    width: 100%;
    margin: auto;    border-bottom: 2px solid #e5e5e5;}
  .box-title  strong {
    font-size: 20px ;
    margin-left: 10px;
    margin-bottom: 8px;
    line-height: 26px;
    height: 50px;
    border-bottom: 2px solid #d80026;
    text-indent: 0.5em;
    color: #d80026;

}
  .box-title  strong a{
    color: #d80026;
    text-decoration: none;
    cursor: pointer;
  }
  .recommend4 a{    text-decoration: none;
    cursor: pointer;
  color: #555;
      white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;}
  .recommend4 li{line-height: 40px;width: 98%;overflow: hidden;text-overflow:ellipsis}
  .recommend3 li:nth-of-type(3n - 2) a, .recommend4 li:nth-of-type(6n - 5) a, .recommend5 li:nth-of-type(5n - 4) a, .recommend6 li:nth-of-type(6n - 5) a, .recommend7 li:nth-of-type(7n - 6) a {
    font-size: 16px;
    font-weight: bold;
    color: #333333;
    background: none;

}
    .el-carousel__item h3 {
    color: #475669;
    font-size: 18px;
    opacity: 0.75;
    line-height: 300px;
    margin: 0;
  }

  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }

  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }
  .searchbar{
    margin: auto;
    width: 800px;
    top: 50%;
  }
  .h1title{
    text-align:center;color: #1065c0;font-size: 30px;font-weight: 700;margin-bottom: 60px
  }
  .abb{
    width: 800px;
    margin: 0px auto 20px;
    text-align: center;

  }
  .homen .abb .el-button{
    border:0px !important;
    font-size: 22px !important;
    color: #409eff !important;
    font-weight: bold !important;
  }
    .homen .abb .el-button:hover{
    border:0px !important;
    font-size: 22px !important;
    color: #d80026 !important;
    font-weight: bold !important;
      background: #fff;
  }
      .homen .abb .el-button:visited{
    border:0px !important;
    font-size: 22px !important;
    color: #d80026 !important;
    font-weight: bold !important;
      background: #fff !important;
  }
        .homen .abb .el-button:active{
    border:0px !important;
    font-size: 22px !important;
    color: #d80026 !important;
    font-weight: bold !important;
      background: #fff !important;
  }
  .homen .abb .el-button:focus{
    border:0px !important;
    font-size: 22px !important;
    color: #d80026 !important;
    font-weight: bold !important;
      background: #fff !important;
  }
  .homen .el-form-item__content {
    margin-left: 0px !important;
  }
  .bottonbanner{
    background: url(../assets/img/backbanner.png) no-repeat center;background-size:100% 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/homeNoHead.vue